module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hideDropdown),
      expression: "hideDropdown"
    }],
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "button-icon user",
    on: {
      "click": function($event) {
        _vm.isActive = !_vm.isActive
      }
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActive),
      expression: "isActive"
    }],
    staticClass: "app-dropdown__menu"
  }, [(_vm.user) ? [_c('li', {
    on: {
      "click": _vm.onLogOut
    }
  }, [_vm._v("Log Out")])] : [_c('li', {
    on: {
      "click": _vm.onLogIn
    }
  }, [_vm._v("Log In")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.onSignUp
    }
  }, [_vm._v("Sign Up")])]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ab82f6c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dropdown.vue
// module id = 2140
// module chunks = 0